export default {
  namespaced: true,
  directory: {
    title: "Diretório",
    name: "Nome",
    position: "Cargo",
    phone1: "Telefone 1",
    phone2: "Telefone 2",
  },
};